import { ReportingScheduler } from "@/entities/reportingScheduler/types";

/**
 * The row, but only as a schedule: a saved report shares its row and has no
 * cadence until it is scheduled, so a cadence-less row is not a schedule.
 */
export const asSchedule = (
  row: ReportingScheduler | null | undefined
): ReportingScheduler | null => (row?.scheduleConfig ? row : null);
